import { useEffect, useState, useCallback } from 'react';
import { without } from 'lodash';
import { marketplaceIntegration } from '@fiverr-private/logo_maker_analytics/dist/esm/mixpanel';
import {
    FILTER_NAME_BY_TYPE,
    LOCATION,
} from '../../../../bi/mixpanel/constants';
import { FILTER } from '../../../shared/constants';
import { useIndustriesContext } from '../../../../shared/IndustriesContext';

const { reportFilterClicked } = marketplaceIntegration;

const useStaticFilters = ({ briefData, setBriefData }) => {
    const [activeFilter, setActiveFilter] = useState(FILTER.BRAND_NAME);
    const [chips, setChips] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState({
        [FILTER.BRAND_NAME]: false,
        [FILTER.INDUSTRY]: false,
        [FILTER.LOGO_ELEMENTS]: false,
    });
    const { getIndustryTitle } = useIndustriesContext();

    useEffect(() => {
        setSelectedFilters({
            [FILTER.BRAND_NAME]:
                briefData.brandName.length + briefData.slogan.length > 0,
            [FILTER.INDUSTRY]: !!briefData.industries.length,
            [FILTER.LOGO_ELEMENTS]: !!briefData.keywords.length,
        });
    }, [briefData]);

    useEffect(() => {
        setChips([
            ...briefData.industries
                .map((value) => ({
                    filter: 'industries',
                    value,
                    title: () => getIndustryTitle(value),
                }))
                .filter((value) => !!value),
            ...briefData.keywords.map((value) => ({
                filter: 'keywords',
                value,
                title: () => value,
            })),
        ]);
    }, [briefData, getIndustryTitle]);

    const handleActiveFilterClick = useCallback(
        (filterType) => () => {
            setActiveFilter(filterType);
            reportFilterClicked(
                FILTER_NAME_BY_TYPE[filterType],
                LOCATION.STATIC
            );
        },
        []
    );

    const handleRemoveChip = (filter, value) => () => {
        const update = { [filter]: without(briefData[filter], value) };
        setBriefData(update, { location: LOCATION.STATIC });
    };

    return {
        activeFilter,
        chips,
        selectedFilters,
        handleActiveFilterClick,
        handleRemoveChip,
    };
};

export default useStaticFilters;
